import React from 'react';
import styled from 'styled-components';
import TrushIcon from '../../../assets/trush.svg';
import ActionToolItem from '../surface/ActionToolItem';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    box-sizing: border-box;
    height: 100%;
    z-index: 5;
`;

const StyledActionToolItem = styled(ActionToolItem)`
    svg {
        width: 40px;
        height: 40px;
    }
`;

type Props = {
    onClickDeleteAll?: () => void;
    onClickVisible?: (visibility: boolean) => void;
    isBackgroundDark?: boolean;
};

const MovieEditorToolLeft: React.FC<Props> = ({
    onClickDeleteAll,
    isBackgroundDark,
}) => {
    return (
        <Container>
            <StyledActionToolItem
                isBackgroundDark={isBackgroundDark}
                icon={TrushIcon ?? ''}
                onClick={onClickDeleteAll}
            >
                編集を削除
            </StyledActionToolItem>
        </Container>
    );
};

export default MovieEditorToolLeft;
